import type {RouteLocationNormalized} from 'vue-router';

export default defineNuxtRouteMiddleware(async function (route: RouteLocationNormalized) {
  const isPreview = useState('storyblok.preview', () => false);

  isPreview.value = !!route.path.match(/(\/\w+)?\/_preview/);

  if (import.meta.client && isPreview.value && !('storyblokRegisterEvent' in window)) {
    throw createError({
      statusCode: 401,
      message: 'Unauthorized outside of Storyblok',
    });
  }
});
